'use client'

import CardOrder from '@/entities/profile-page/historyOrders/CardOrder'
import { useInView } from 'react-intersection-observer'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import { useGetHistoryOrdersMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'

export const HistoryOrders = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    const { userInfo } = useGetIsAuthUser()
    const [getOrders] = useGetHistoryOrdersMutation()
    const [orders, setOrders] = useState([])

    useEffect(() => {
        getOrders(userInfo.id)
            .unwrap()
            .then((res) => {
                if (res.data) {
                    setOrders(Object.values(res.data))
                }
            })
    }, [])

    return (
        <div
            ref={ref}
            className={`HistoryOrders ${
                inView && 'animate__animated animate__zoomInRight'
            }`}
        >
            <h2>Мои заказы</h2>
            <div className={'history-content'}>
                {!orders.length && <h3>Нет заказов</h3>}
                {orders?.map((order) => (
                    <CardOrder key={order.order_id} orderData={order} />
                ))}
            </div>
        </div>
    )
}
